<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="原合同信息" name="1">
        <van-field v-model="inputForm.code" label="合同编号" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.ylessorName" label="甲方" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.ycustomerName" label="乙方" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.dateRange" label="合同期限" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.bunkCode" label="铺位编号" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.bunkName" label="铺位名称" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.brandName" label="经营品牌" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="变更信息" name="2">
        <van-field v-model="inputForm.changeTypeName" label="变更类型" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.remarks" label="变更说明" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-row>
          <van-col span="24">
            <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
              <p>附件</p>
              <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
            </div>
          </van-col>
        </van-row>
      </van-collapse-item>
      <van-collapse-item title="租赁甲方变更" name="3"  v-if="inputForm.changeType&&inputForm.changeType.includes('1')">
        <van-field v-model="inputForm.ylessorName" label="原甲方" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.lessorName" label="新甲方" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
      </van-collapse-item>
	  <van-collapse-item title="物业甲方变更" name="8"  v-if="inputForm.changeType&&inputForm.changeType.includes('6')">
	    <van-field v-model="inputForm.ywuyeLessorName" label="原甲方" label-width="100px" readonly autosize rows='1'
	               type="textarea"/>
	    <van-field v-model="inputForm.wuyeLessorName" label="新甲方" label-width="100px" readonly autosize rows='1'
	               type="textarea"/>
	  </van-collapse-item>
      <van-collapse-item title="乙方变更" name="4"  v-if="inputForm.changeType&&inputForm.changeType.includes('2')">
        <van-field v-model="inputForm.ycustomerName" label="原乙方" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.customerName" label="新乙方" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
      </van-collapse-item>
<!--      <van-collapse-item title="收费标准及应收周期变更" name="2">-->
<!--        <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered-->
<!--                 :items="inputForm.leasingResources" :fields="fields1">-->
<!--          <template v-slot:head()="scope">-->
<!--            <div class="text-nowrap" :style="{textAlign:'center'}">-->
<!--              {{ scope.label }}-->
<!--            </div>-->
<!--          </template>-->
<!--          <template v-slot:cell(index)="data">-->
<!--            {{ data.index + 1 }}-->
<!--          </template>-->
<!--          <template v-slot:table-colgroup="scope">-->
<!--            <col-->
<!--                v-for="field in scope.fields"-->
<!--                :key="field.key"-->
<!--                :style="{ width: field.key === 'index' ?'30px':'80px'}"-->
<!--            />-->
<!--          </template>-->
<!--        </b-table>-->
<!--        <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered-->
<!--                 :items="items2" :fields="fields2">-->
<!--          <template v-slot:head()="scope">-->
<!--            <div class="text-nowrap" :style="{textAlign:'center'}">-->
<!--              {{ scope.label }}-->
<!--            </div>-->
<!--          </template>-->
<!--          <template v-slot:cell(index)="data">-->
<!--            {{ data.index + 1 }}-->
<!--          </template>-->
<!--          <template v-slot:table-colgroup="scope">-->
<!--            <col-->
<!--                v-for="field in scope.fields"-->
<!--                :key="field.key"-->
<!--                :style="{ width: field.key === 'index' ?'30px':'80px'}"-->
<!--            />-->
<!--          </template>-->
<!--        </b-table>-->
<!--      </van-collapse-item>-->
<!--      <van-collapse-item :title="inputForm.changeType.includes('3')&&inputForm.changeType.includes('4')?'应收周期变更/收费标准变更-租金应收明细':(inputForm.changeType.includes('3')?'应收周期变更-租金应收明细':'收费标准变更-租金应收明细')" name="5"  v-if="inputForm.changeType&&inputForm.changeType.includes('3')||inputForm.changeType&&inputForm.changeType.includes('4')">-->
      <van-collapse-item title="租金应收调整明细" name="5"  v-if="inputForm.changeType&&inputForm.changeType.includes('3')||inputForm.changeType&&inputForm.changeType.includes('4')">
        <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
                 :items="items3" :fields="fields3" class="aa">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'index' ?'30px':'80px'}"
            />
          </template>
        </b-table>
      </van-collapse-item>
<!--      <van-collapse-item :title="inputForm.changeType.includes('3')&&inputForm.changeType.includes('4')?'应收周期变更/收费标准变更-其他应收明细':(inputForm.changeType.includes('3')?'应收周期变更-租金应收明细':'收费标准变更-其他应收明细')" name="6"  v-if="inputForm.changeType&&inputForm.changeType.includes('3')||inputForm.changeType&&inputForm.changeType.includes('4')">-->
      <van-collapse-item title="其他应收调整明细" name="6"  v-if="inputForm.changeType&&inputForm.changeType.includes('3')||inputForm.changeType&&inputForm.changeType.includes('4')">
        <b-table striped small sticky-header sticky-header="calc(100vh - 50px)" head-variant="light" responsive bordered
                 :items="items4" :fields="fields4" class="aa">
          <template v-slot:head()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'index' ?'30px':'80px'}"
            />
          </template>
        </b-table>
      </van-collapse-item>
      <van-collapse-item title="品牌业态调整" name="7"  v-if="inputForm.changeType&&inputForm.changeType.includes('5')">
        <van-field v-model="inputForm.ybcategoryName" label="原经营业态" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.bcategoryName" label="新经营业态" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.ybrandName" label="原经营品牌" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.brandName" label="新经营品牌" label-width="100px" readonly autosize rows='1'
                   type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="会签单附件" name="8" style="margin-top: 8px;" v-if="inputForm.hqAttachList&&inputForm.hqAttachList.length > 0">
        <div style="padding-left: 16px;">
<!--          <p>最终附件</p>-->
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.hqAttachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
          <p v-if="inputForm.hqAttachList&&inputForm.hqAttachList.length==0">无</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import NewContractsService from '@/api/contract/NewContractsService.js'
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {BTable} from 'bootstrap-vue'
import processRecord from "../../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8'],
      isshow: false,
      radio: '',
      inputForm: {
        contractId: '',
        code: '',
        customerName: '',
        mobile: '',
        changeType: '',
        bcategoryName: '',
        brandName: '',
        details: [{
          feeItemId: '',
          feeNormId: '',
          feeNormName: '',
          unitPrice: undefined,
          newUnitPrice: undefined,
        }],
        isDoTask: false,
        isLastTask: false
      },
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'leasingResourcesCode', stickyColumn: true, label: '资源编号'},
        {key: 'area', stickyColumn: true, label: '最终档案面积（㎡）'},
        {key: 'propertyArea', label: '租赁建筑面积（㎡）'},
        {key: 'inPropertyArea', label: '租赁套内面积（㎡）'},
        {key: 'chargingPropertyArea', label: '计费面积（㎡）'},
        {key: 'unitPrice', label: '单价（元/㎡/日）'},
      ],
      fields2: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'leasingResourcesCode', stickyColumn: true, label: '资源编号'},
        {key: 'feeItemName', stickyColumn: true, label: '收费项目'},
        {key: 'feeNormName', label: '收费标准'},
        {key: 'payPeriodName', label: '付款周期'},
        {key: 'buildTypeName', label: '应收生成方式'},
      ],
      fields3: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'payDeadlineDate', stickyColumn: true, label: '应收截止日期'},
        {key: 'startDate', stickyColumn: true, label: '计费开始日期'},
        {key: 'endDate', label: '计费截止日期'},
        // {key: 'unitPrice', label: '单价（元/㎡/日）'},
        {key: 'amount', label: '应收金额（元）'},
        // {key: 'rate', label: '涨幅（%）'},
      ],
      fields4: [
        {key: 'index', stickyColumn: true, label: '序号'},
        {key: 'feeItemName', stickyColumn: true, label: '费项名称'},
        {key: 'feeNormName', stickyColumn: true, label: '收费标准'},
        {key: 'startDate', label: '应收开始日期'},
        {key: 'endDate', label: '应收截止日期'},
        // {key: 'unitPrice', label: '单价（元/㎡/日）'},
        {key: 'amount', label: '应收金额（元）'},
      ],
      items1: [],
      items2: [],
      items3: [],
      items4: [],
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)
    // this.init('1766355208971689985')

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      new NewContractsService().queryByChangeId(id).then(({data}) => {
        this.inputForm = data
        const changeTypeMappings = {
          '1': '租赁甲方变更',
          '2': '乙方变更',
          '3': '应收周期变更',
          '4': '收费标准变更',
          '5': '品牌业态变更',
		  '6': '物业甲方变更'
        };
        this.inputForm.changeType = this.inputForm.changeType.split(',')
        this.inputForm.changeTypeName = this.inputForm.changeType.filter(type => changeTypeMappings.hasOwnProperty(type)).map(type => changeTypeMappings[type]).join('、');
        this.inputForm.dateRange = `${data.startDate}至${data.endDate}`
        this.inputForm.leasingResources.forEach((i) => {
          i.leasingResourcesFeenorms.forEach(item => {
            item.leasingResourcesCode = i.leasingResourcesCode
          })
          this.items2.push(...i.leasingResourcesFeenorms)
          i.area = i.lastPropertyArea
        })
        this.items3 = data.groupLastReceivable.rents
        this.items4 = data.groupLastReceivable.others
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars}
        _this.auditForm.message = _this.inputForm.remarks

		_this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'shye_contract_change',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: _this.inputForm.isLastTask ? 4 : 2,
				formKey: _this.formKey
			}
            new NewContractsService().startFlowChange(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
            _this.$toast.clear();
            _this.$toast.success('提交成功');
            //更新数据库状态
			let form = {
				id: _this.inputForm.id,
				flowType: 3,
				formKey: _this.formKey
			}
            new NewContractsService().startFlowChange(form);

            setTimeout(function () {
              _this.close()
            }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
<style>
.aa .table tr th:nth-child(2), tr td:nth-child(2) {
  left: 30px !important;
}

.aa .table tr th:nth-child(3), tr td:nth-child(3) {
  left: 110px !important;
}
</style>
